import React, { useEffect, useState } from "react";

import { getCurrentUserEmailAsync } from "../auth";
import LoadingSpinner from "../components/fikseLoadingLetter";
import { ReactComponent as ChevronRightIcon } from "../images/icons-fikse/chevron_clean_size.svg";
import { ReactComponent as InfoIcon } from "../images/icons-fikse/info.svg";
import { Button } from "../ui/button";
import { checkIfUserIsTailorModerator } from "./DashboardPage";

export default function TailorAdminPage() {
  const [isTailorModerator, setIsTailorModerator] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    //Vi take getCurrentUserEmailAsync from dashbordpage and utelizes it to check weather
    const checkTailorModerator = async () => {
      const email = await getCurrentUserEmailAsync();

      const isTailorModerator = await checkIfUserIsTailorModerator(
        email ?? "asd@asd.asd"
      );
      setIsTailorModerator(isTailorModerator);
      console.log("isTailorModerator", isTailorModerator);

      if (!isTailorModerator) {
        window.location.href = "/dashboard";
        await new Promise((resolve) => setTimeout(resolve, 2000));
      }
      setLoading(false);
    };
    checkTailorModerator();
  }, []);

  const mainScreen = () => {
    return (
      <>
        <div className="fikseTextHeader">€Admin Settings</div>
        <div className="fikseTextGrey defaultPaddingLeft w-2/5 pb-16">
          €Give people access to your Fikse company profile, sharing link and be happy{" "}
        </div>
        <Button variant="white" className="justify-between border-t border-black">
          €Edit admin profile <ChevronRightIcon className="defaultIconSize" />
        </Button>{" "}
        <Button variant="white" className="justify-between">
          €Edit access <ChevronRightIcon className="defaultIconSize" />
        </Button>
        <Button variant="white" className="justify-between">
          €Service categories <ChevronRightIcon className="defaultIconSize" />
        </Button>
      </>
    );
  };

  if (loading) return <LoadingSpinner />;
  return (
    <div className="mx-auto mt-20 h-screen max-w-screen-lg border border-black">
      {mainScreen()}
    </div>
  );
}
